module.exports = __webpack_public_path__ + "assets/img/BD.0ceb81db.png";